import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Select extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentIndex: -1,
      open: false,
      focus: false
    }

    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  handleChange = (value, index) => {
    const { onChange, name } = this.props
    this.setState({ value: value, currentIndex: index })

    if (typeof onChange === 'function') {
      this.props.onChange({
        target: { name, value }
      })
    }
  }

  handleKeyDown (e) {
    if (e.keyCode === 39 || e.keyCode === 40) {
      var nextIndex = this.state.currentIndex + 1
      if (nextIndex < this.props.options.length) {
        this.handleChange(this.props.options[nextIndex], nextIndex)
      }
    } else if (e.keyCode === 37 || e.keyCode === 38) {
      var previousIndex = this.state.currentIndex - 1
      if (previousIndex >= 0) {
        this.handleChange(this.props.options[previousIndex], previousIndex)
      }
    }
    e.preventDefault()
  }

  IsRequired () {
    if (this.props.required) return <span className='required'>*</span>
  }

  HasEmptyValue () {
    if (this.props.hasEmpty && this.props.hasEmpty === true) {
      return (
        <li value='' onClick={() => this.handleChange('', -1)}>
          Selecione
        </li>
      )
    }
  }

  IsValid () {
    if (this.props.valid === true) {
      return (
        <span className='message message-success icon icon_check'>
          {this.props['data-success']}
        </span>
      )
    } else if (this.props.valid === false) {
      return (
        <span className='message message-error icon icon_check'>
          {this.props['data-error']}
        </span>
      )
    }
  }

  GetContainerClasses () {
    return classNames({
      select: true,
      'has-content': this.props.value || this.props.placeholder,
      open: this.state.open,
      success: this.props.valid === true,
      error: this.props.valid === false
    })
  }

  GetOptionsStyle () {
    if (this.state.open === true) {
      return {
        display: 'block'
      }
    }
  }

  getOptionTextSelected = () => {
    const { value } = this.props
    const { options, placeholder, displayValue, selectedValue } = this.props
    if (!value) return placeholder || ''

    const option = options.find(item => item[selectedValue] === value[selectedValue])

    if (option) return option[displayValue]

    return ''
  }

  buildOptions = () => {
    const { options, displayValue, selectedValue, image } = this.props

    return options.map((item, index) => {
      const text = item[displayValue]
      const value = item[selectedValue]
      const img = image ? <img src={item[image]} alt={item[image]} /> : ''
      const classImg = image ? 'select-img' : ''

      return (
        <li
          key={index}
          value={value}
          onClick={() => this.handleChange(item, index)}
          className={`txt-body-sm ${classImg}`}
        >
          {text}
          {img}
        </li>
      )
    })
  }

  HasIcon () {
    if (this.props.iconName && this.props.valid === undefined) {
      return <span className={`icon ${this.props.iconName}`} />
    }
  }

  render () {
    return (
      <div className={`form-field ${this.props.className || ''}`}>
        <div
          className={this.GetContainerClasses()}
          id={this.props.id}
          name={this.props.name}
          disabled={this.props.disabled}
          onClick={() =>
            !this.props.disabled
              ? this.setState({
                open: !this.state.open,
                focus: true
              })
              : null
          }
          onBlur={() =>
            !this.props.disabled
              ? this.setState({ open: false, focus: false })
              : null
          }
          tabIndex={0}
          onKeyDown={this.handleKeyDown}
        >
          <div className='select-styled'>{this.getOptionTextSelected()}</div>
          <ul className='select-options' style={this.GetOptionsStyle()}>
            {this.HasEmptyValue()}
            {this.buildOptions()}
          </ul>
        </div>
        <label htmlFor={this.props.id}>
          {this.props.label}
          {this.IsRequired()}
        </label>
        {this.HasIcon()}
        {this.IsValid()}
      </div>
    )
  }
}

Select.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  'data-error': PropTypes.string,
  'data-success': PropTypes.string,
  valid: PropTypes.bool,
  onChange: PropTypes.func,
  selectedValue: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  iconName: PropTypes.string,
  hasEmpty: PropTypes.bool,
  image: PropTypes.string
}

export default Select



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/Select.js